var WayPoints = (function () {
  function init() {
    $(document).ready(function () {
      // Basic Animation directions

      $(' .acr-fdown').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-down');
        }, {
          offset: '100%',
        });
      });

      $(' .acr-ftop ').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-top');
        }, {
          offset: '100%',
        });
      });

      $(' .acr-fbottom-scatter').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-up-scatter');
        }, {
          offset: '100%',
        });
      });

      $(' .acr-fbottom-scatter-short').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-up-scatter-short');
        }, {
          offset: '100%',
        });
      });

      $(' .acr-fbottom ').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-up');
        }, {
          offset: '100%',
        });
      });


      $('.acr-fleft').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-left');
        }, {
          offset: '100%',
        });
      });

      $('.acr-fright').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-right');
        }, {
          offset: '100%',
        });
      });


      // special to underline in headdings
      $(' .acr-underheading.acr-fcenter').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('acr-fill-from-center');
        }, {
          offset: '100%',
        });
      });

      $(' .acr-fcenter-is-grey').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('acr-fill-from-center-is-grey');
        }, {
          offset: '100%',
        });
      });

      // Use of stagger (ie: Headings - staggering header + underline
      $(' .acr-fbottom-scatter .acr-stagger').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-up-scatter');
        }, {
          offset: '100%',
        });
      });

      $(' .acr-ftop .acr-stagger').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-top');
        }, {
          offset: '100%',
        });
      });

      $('.acr-fbottom .acr-stagger').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-up');
        }, {
          offset: '100%',
        });
      });

      $('.acr-fleft .acr-stagger').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-left');
        }, {
          offset: '100%',
        });
      });

      $('.acr-fright .acr-stagger').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-right');
        }, {
          offset: '100%',
        });
      });

      // Vehicle Line Up gallery specific
      $('.acr-scattered .acr-lineup').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in');
        }, {
          offset: '100%',
        });
      });

      // Vehicle Line Up gallery *DIRECTIONAL
      $('.acr-scattered .acr-lineup.ftop').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-top');
        }, {
          offset: '100%',
        });
      });

      // Vehicle Line Up gallery specific
      $('.acr-scattered .acr-lineup.fbottom').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-in-bottom');
        }, {
          offset: '100%',
        });
      });

      // shopiing tools
      $('.acr-fade-zoom').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('acr-fade-in');
        }, {
          offset: '100%',
        });
      });

      // Keystory trigger Zoomit
      $('.key-image').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('zoomit');
        }, {
          offset: '70%',
        });
      });

      $('.key-headline').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('zoom-it-2');
        }, {
          offset: '100%',
        });
      });

      $('.acr-fade-scale').each(function () {
        $(this).waypoint(function () {
          $(this.element).addClass('animated acr-fade-scale-up');
        }, {
          offset: '100%',
        });
      });


    });
  }

  return {
    init: init,
  };
}());
